<template>
	<Dialog
		v-model:visible="$store.state.fathers.dialog"
		:breakpoints="{ '960px': '75vw', '640px': '90vw' }"
		:style="{ width: '30vw' }"
		:modal="dialogDefaults.modal"
		:closeOnEscape="dialogDefaults.closeOnEscape"
		:dismissableMask="dialogDefaults.dismissableMask"
		@hide="hide"
		@show="show"
	>
		<template #header>
			<FormTitle :title="title" />
		</template>

		<form @keydown="$event.key === 'Enter' ? save() : null">
			<div class="row gy-3 pt-3">
				<div class="col-12">
					<InputText
						ref="nombre"
						label="Nombre"
						:disabled="disabled"
						:error="form.errors.get('nombre')"
						@change-value="(value) => (form.nombre = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="apellido_1"
						label="Primer apellido"
						:disabled="disabled"
						:error="form.errors.get('apellido_1')"
						@change-value="(value) => (form.apellido_1 = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="apellido_2"
						label="Segundo apellido"
						:disabled="disabled"
						:error="form.errors.get('apellido_2')"
						@change-value="(value) => (form.apellido_2 = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="direccion"
						label="Dirección"
						:disabled="disabled"
						:error="form.errors.get('direccion')"
						@change-value="(value) => (form.direccion = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="telefono"
						label="Teléfono"
						:disabled="disabled"
						:error="form.errors.get('telefono')"
						@change-value="(value) => (form.telefono = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="dni"
						label="DNI"
						:disabled="disabled"
						:error="form.errors.get('dni')"
						@change-value="(value) => (form.dni = value)"
					/>
				</div>
				<div class="col-12">
					<DropDown
						ref="id_centro"
						label="Centro"
						:options="centers.list"
						optionValue="id_centro"
						optionLabel="nombre"
						:displayText="'nombre'"
						:disabled="disabled"
						:error="form.errors.get('id_centro')"
						@change-value="(value) => (form.id_centro = value)"
					/>
				</div>
				<div class="col-12">
					<InputText
						ref="email"
						label="Email"
						:disabled="disabled"
						:error="form.errors.get('email')"
						@change-value="(value) => (form.email = value)"
					/>
				</div>
				<div class="col-12">
					<InputPassword
						ref="password"
						label="Contraseña"
						:disabled="disabled"
						:error="form.errors.get('password')"
						@change-value="(value) => (form.password = value)"
					/>
				</div>
				<div class="col-12">
					<InputPassword
						ref="password_confirmation"
						label="Repetir contraseña"
						:disabled="disabled"
						:error="form.errors.get('password_confirmation')"
						@change-value="(value) => (form.password_confirmation = value)"
					/>
				</div>
			</div>
		</form>

		<template #footer v-if="!disabled">
			<div class="col-12 d-flex justify-content-between">
				<Button
					@click="
						toggleFormDialog({
							stateVariable: stateVariable,
							show: false,
						})
					"
					label="Cancelar"
					:disabled="form.busy"
					class="bg-white border border-primary text-primary"
				/>
				<Button @click="save()" label="Guardar" :disabled="form.busy" />
			</div>
		</template>
	</Dialog>
</template>

<script>
	import Form from "vform";
	import { mapActions, mapMutations, mapState } from "vuex";

	export default {
		props: {
			route: {
				type: String,
				required: true,
			},
			stateVariable: {
				type: String,
				required: true,
			},
		},
		data: () => ({
			form: new Form(),
			modelName: "padre",
			title: `Añadir padre`,
			disabled: false,
			lastPageChange: null,
		}),
		methods: {
			...mapActions(["sendForm", "getRegisters"]),
			...mapMutations(["toggleFormDialog", "changeCurrentRegister"]),
			save() {
				const update = this.fathers.register != null;
				const url = `/fathers${
					update ? `/${this.fathers.register.id_padre}` : ""
				}`;

				this.sendForm({
					method: update ? "put" : "post",
					form: this.form,
					url: url,
					errors: this.form.errors,
				}).then((response) => {
					if (response.status === 200) {
						this.toggleFormDialog({
							stateVariable: this.stateVariable,
							show: false,
						});

						this.getRegisters({
							route: this.route,
							stateVariable: this.stateVariable,
							page: this.fathers.currentPage,
							rows: this.fathers.rows,
						});
					}
				});
			},
			hide() {
				this.title = `Añadir ${this.modelName}`;
				this.disabled = false;

				this.changeCurrentRegister({
					stateVariable: this.stateVariable,
					register: null,
				});
			},
			clearForm() {
				this.form.clear();
				this.form.reset();

				for (const key in this.$refs) {
					if (Object.hasOwnProperty.call(this.$refs, key)) {
						this.$refs[key].model = null;
					}
				}
			},
			show() {
				this.clearForm();

				const register = this.fathers.register;

				if (register != null) {
					for (const key in register) {
						if (
							Object.hasOwnProperty.call(register, key) &&
							this.$refs[key] != undefined
						) {
							this.$refs[key].model = register[key];
						}
					}

					if (this.fathers.dialogMode == "edit") {
						this.title = `Editar ${this.modelName}`;
						this.disabled = false;
					} else {
						this.title = `Ver ${this.modelName}`;
						this.disabled = true;
					}
				}
			},
		},
		computed: {
			...mapState(["dialogDefaults", "fathers", "centers"]),
		},
	};
</script>
